import { Search } from '@mui/icons-material';
import React from 'react';
import { GradientTextAction } from 'src/common';
import { useStateSelector } from 'src/redux';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 12px;

  svg {
    width: 18px;
    height: 18px;
  }

  input {
    flex: 1;
    height: 40px;
    outline: none;
    border: none;
    padding: 0 10px;
    color: ${({ theme }) => theme.colors.prussianBlue};
    background-color: ${({ theme }) => theme.colors.cultured};
    font-size: 13px;

    ::placeholder {
      font-size: 13px;
      color: ${({ theme }) => theme.colors.cflowerBlue};
      font-weight: 500;
    }
  }
`;

interface HeaderProps {
  onChange: (value: string) => void;
  showViewGlobal: boolean;
  onViewGlobal: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onChange, showViewGlobal, onViewGlobal }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);

  return (
    <Div>
      <Search
        style={{
          color: colors.prussianBlue,
        }}
      />
      <input
        type="search"
        onInput={(e) => {
          // @ts-ignore
          onChange(e.target.value);
          mpEvent(MPEvents.TableSearch, {});
        }}
        placeholder="Search by keyword ..."
      />
      {showViewGlobal && (
        <GradientTextAction nowrap $underline weight={500} px={12} onClick={onViewGlobal}>
          View global
        </GradientTextAction>
      )}
    </Div>
  );
};
